import React, { useContext, useMemo, useState, useEffect, useRef } from 'react';
import Joyride, { STATUS } from 'react-joyride';
import { ListGroup, Dropdown, Card, Row, Col, Collapse, Modal, Button } from 'react-bootstrap';
import { Tooltip } from '@mui/material';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { ConfigContext } from '../../../../contexts/ConfigContext';
import useAuth from '../../../../hooks/useAuth';
import { decode as base64_decode } from 'base-64';
import axios from '../../../../services/axios';
import lupa from '../../../../assets/images/lupa.png';
import lupav from '../../../../assets/images/lupav.png';

import useTenantNotifications from '../../../../hooks/useTenantNotifications';
import { mapTenantNotificationsToDropdownItems } from '../../../../utils/tenantNotificationsUi';

import { IMGPERFIL, NOMEPERFIL, TIPOTESTE, MENU_USUARIO, CHANGEDDATAUSER } from '../../../../store/actions';
import { FormatCnpjCpf } from '../../../../components/Utilitarios/Funcoes';
import { perfilAvatar0, perfilAvatar1, perfilAvatar2, perfilAvatar3, perfilAvatar4, perfilAvatar5, perfilAvatar6, perfilAvatar7, perfilAvatar8, perfilAvatar9, perfilAvatar10, perfilAvatar11, perfilAvatar12, perfilAvatar13, perfilAvatar14, perfilAvatar15, perfilAvatar16, perfilAvatar17, perfilAvatar18, perfilAvatar19, perfilAvatar20, perfilAvatar21, perfilAvatar22, perfilAvatar23, perfilAvatar24, perfilAvatar25, perfilAvatar26, perfilAvatar27, perfilAvatar28, perfilAvatar29, perfilAvatar30, perfilAvatar31, perfilAvatar32 } from '../../../../components/Utilitarios/imagens/perfil';

import ModalIntegracoes from '../../../../views/modal/modalIntegracoes';
import ModalCartaAberta from '../../../../components/ModalCartaAberta';
import CupomDesconto from '../../../../components/CupomDesconto'
import Swal from 'sweetalert2';
import { CheckSessaoUser } from '../../../../components/Utilitarios/Funcoes';
import packageJson from '../../../../../package.json';

const DOSSIE_NOTIFICATION_TYPE = 'dossie_mensal';
const DOWNLOAD_NOTIFICATION_TYPE = 'download_ready';

const isTenantNotificationRead = (notification) => notification?.data_hora_leitura !== 'null' && notification?.data_hora_leitura !== null;

const mapVariantToSwalIcon = (variant) => {
  if (variant === 'success') return 'success';
  if (variant === 'warning') return 'warning';
  if (variant === 'danger') return 'error';
  return 'info';
};

const NavRight = (props) => {
  const configContext = useContext(ConfigContext);
  const { dispatch } = configContext;
  const ref = useRef();
  const { logout } = useAuth();
  const { rtlLayout, ws } = configContext.state;
  const [showModalIntegracoes, setShowModalIntegracoes] = useState(false);
  const [avatarAtual, setAvatarAtual] = useState(perfilAvatar1);
  const [username, setUsername] = useState(''); // faltou criar o STATE para atualizar o nome do usuário
  const [isOnline, setIsOnline] = useState(false);
  const [isNewNoti, setIsNewNoti] = useState(false);
  const [boolAlertas, setBoolAlertas] = useState(true);
  const location = useLocation();
  const history = useHistory();
  const storage_ = sessionStorage.getItem(`ddesp`);
  const [isDemonstracao, setIsDemonstracao] = useState(false);
  const [accordionKey, setAccordionKey] = useState(0);
  const [dataIni, setDataIni] = useState([]);
  const [ocultaMenus, setOcultaMenus] = useState(false);
  const [moduloAtual, setModuloAtual] = useState(configContext.state.moduloAtual);
  const [displayTrocarEmpresa, setDisplayTrocarEmpresa] = useState(false);
  const [displayFecharDropConta, setDisplayFecharDropConta] = useState(false);
  const caminhoAtual = location.pathname;
  const [mostrarBadgeNovidades, setMostrarBadgeNovidades] = useState(true);
  const [mostrarAtalhoNovidades, setMostrarAtalhoNovidades] = useState(true);
  const [runTourNovidades, setRunTourNovidades] = useState(false);
  const [tourStepIndex, setTourStepIndex] = useState(0);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showIntroModal, setShowIntroModal] = useState(false);
  const [showBellDropdown, setShowBellDropdown] = useState(false);
  const [showHelpDropdown, setShowHelpDropdown] = useState(false);
  const [modalNotif, setModalNotif] = useState(null);
  const lastShownDossieNotificationIdRef = useRef(null);
  const shownDownloadNotificationIdsRef = useRef(new Set());

  // ── Fast-poll após download async ────────────────────────────────────────
  // Quando um download vai para fila assíncrona, aceleramos o polling para
  // 2,5 min. Assim que o inbox cresce (nova notificação chega), voltamos a 5 min.
  const [fastPoll, setFastPoll] = useState(false);
  const inboxLenRef = useRef(0);

  useEffect(() => {
    const handler = () => setFastPoll(true);
    window.addEventListener('espiao:async-download-started', handler);
    return () => window.removeEventListener('espiao:async-download-started', handler);
  }, []);

  const {
    inbox,
    unreadIds: notificacoesNaoLidasIds,
    badgeText: spanNotificacoes,
    markReadBatch,
  } = useTenantNotifications({ pollingIntervalMs: fastPoll ? 60000 : 180000 });

  useEffect(() => {
    if (fastPoll && inbox.length > inboxLenRef.current) {
      setFastPoll(false);
    }
    inboxLenRef.current = inbox.length;
  }, [inbox, fastPoll]);

  const notificacoesArray = useMemo(
    () => mapTenantNotificationsToDropdownItems(inbox, { lupa, lupav, onOpenModal: setModalNotif }),
    [inbox]
  );

  useEffect(() => {
    const latestDossieNotification = (Array.isArray(inbox) ? inbox : [])
      .filter((notification) => String(notification?.type || notification?._raw?.type || '').trim().toLowerCase() === DOSSIE_NOTIFICATION_TYPE && !isTenantNotificationRead(notification))
      .sort((a, b) => Number(b?.id || b?.key || 0) - Number(a?.id || a?.key || 0))[0];

    if (!latestDossieNotification) {
      lastShownDossieNotificationIdRef.current = null;
      return;
    }

    const latestId = Number(latestDossieNotification?.id || latestDossieNotification?.key || latestDossieNotification?._raw?.id || 0);
    if (!Number.isFinite(latestId) || latestId <= 0) return;
    if (lastShownDossieNotificationIdRef.current === latestId) return;

    lastShownDossieNotificationIdRef.current = latestId;

    const ctaLink = latestDossieNotification?.link || null;
    Swal.fire({
      icon: mapVariantToSwalIcon(latestDossieNotification?.fundo),
      title: latestDossieNotification?.titulo || 'Dossiê automático',
      text: latestDossieNotification?.texto || 'Seu dossiê automático tem uma nova atualização.',
      confirmButtonText: 'Entendi',
      confirmButtonColor: '#4099ff',
      showDenyButton: !!ctaLink,
      denyButtonText: 'Visualizar',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed || result.isDenied) {
        markReadBatch([latestId]);
      }
      if (result.isDenied && ctaLink) {
        window.open(ctaLink, '_blank', 'noopener,noreferrer');
      }
    });
  }, [inbox, markReadBatch]);

  useEffect(() => {
    const pendingDownloads = (Array.isArray(inbox) ? inbox : [])
      .filter((notification) => String(notification?.type || notification?._raw?.type || '').trim().toLowerCase() === DOWNLOAD_NOTIFICATION_TYPE && !isTenantNotificationRead(notification));

    if (pendingDownloads.length === 0) return;

    const novos = pendingDownloads.filter((n) => {
      const id = Number(n?.id || n?.key || n?._raw?.id || 0);
      return id > 0 && !shownDownloadNotificationIdsRef.current.has(id);
    });

    if (novos.length === 0) return;

    novos.forEach((n) => {
      const id = Number(n?.id || n?.key || n?._raw?.id || 0);
      if (id > 0) shownDownloadNotificationIdsRef.current.add(id);
    });

    const total = novos.length;
    const allNewIds = novos.map((n) => Number(n?.id || n?.key || n?._raw?.id || 0)).filter(Boolean);
    const isSingle = total === 1;
    const ctaLink = isSingle ? (novos[0]?.link || null) : null;

    Swal.fire({
      icon: 'success',
      title: isSingle ? 'Download pronto!' : `${total} downloads prontos!`,
      html: isSingle
        ? (novos[0]?.texto || 'Seu arquivo está disponível para download.')
        : `Você tem <strong>${total}</strong> arquivos disponíveis na central de downloads.`,
      confirmButtonText: isSingle
        ? '<i class="mdi mdi-download"></i> Baixar arquivo'
        : '<i class="mdi mdi-download-multiple"></i> Ver downloads',
      confirmButtonColor: '#2ed8b6',
      showDenyButton: true,
      denyButtonText: 'Depois',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed || result.isDenied) {
        markReadBatch(allNewIds);
      }
      if (result.isConfirmed) {
        if (isSingle && ctaLink) {
          window.open(ctaLink, '_blank', 'noopener,noreferrer');
        } else {
          history.push('/central-de-downloads');
        }
      }
    });
  }, [inbox, markReadBatch, history]);

  // Estado do onboarding
  const [onboardingIncompleto, setOnboardingIncompleto] = useState(false);
  const [statusOnboarding, setStatusOnboarding] = useState(null);

  const tourSteps = [
    {
      target: '#menuRP',
      content: 'Basta abrir o menu do usuário clicando aqui.',
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: '#menuNovidades',
      content: 'Agora, clique em "Novidades" para ver o que mudou.',
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: '#menuNovidades',
      content: (
        <div>
          <p className='mb-2'>Pronto! Você pode acessar as Novidades quando quiser.</p>
          <Button
            size='sm'
            variant='primary'
            onClick={() => {
              // Marca como visto ao acessar Novidades pelo CTA do tour
              localStorage.setItem('novidadesBadgeVisto', 'true');
              setMostrarBadgeNovidades(false);
              setMostrarAtalhoNovidades(false);
              setRunTourNovidades(false);
              setShowUserDropdown(false);
              history.push('/novidades');
            }}
          >
            Acessar Novidades
          </Button>
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
  ];

  let nomeEmpresa = '';
  let cnpjCpf = '';
  let tituloPlano = <></>;
  let usersRt = null;
  let users = null;
  let varias = false;
  let nomeDoPlano = '';
  let isMasterUser = false;

  if (storage_ !== null) {
    usersRt = sessionStorage.getItem(`ddesp`) !== null ? JSON.parse(base64_decode(sessionStorage.getItem(`ddesp`))) : null;
    users = usersRt;
    nomeEmpresa = users[1].toUpperCase();
    cnpjCpf = users[2] !== null && users[2] > '' ? FormatCnpjCpf(users[2]) : '';
    varias = users[18];
    nomeDoPlano = users[17];
    // Verifica se é o usuário master (users[3] = uid, users[5] = usuario_id_master)
    isMasterUser = users.length > 5 ? users[3] === users[5] : false;
    tituloPlano =
      users[16] === true ? (
        ''
      ) : (
        <Tooltip
          title='Plano Contratado'
          placement='left'
          arrow
        >
          <span className='f-w-600 f-14'>{nomeDoPlano}</span>
        </Tooltip>
      );
  }

  const resolveBool = (v) => {
    if (v === true) return true;
    if (v === false) return false;
    const s = String(v ?? '').trim().toLowerCase();
    if (s === 't' || s === 'true' || s === '1' || s === 'yes') return true;
    if (s === 'f' || s === 'false' || s === '0' || s === 'no' || s === '') return false;
    // fallback: qualquer string diferente das acima será tratada como false
    return false;
  };

  const handleOpenSeguranca = (e) => {
    if (e?.preventDefault) e.preventDefault();
    if (!isMasterUser) return;
    setShowUserDropdown(false);
    history.push('/seguranca');
  };

  // Controle do selo/atalho "NOVO" nas novidades (apenas até o primeiro clique)
  useEffect(() => {
    const visto = localStorage.getItem('novidadesBadgeVisto');
    const deveMostrar = visto !== 'true';
    setMostrarBadgeNovidades(deveMostrar);
    setMostrarAtalhoNovidades(deveMostrar);
  }, []);

  const handleClickNovidadesStar = (e) => {
    // Abre modal de introdução; tour inicia após confirmar
    // Observação: não marcamos como visto aqui para só ocultar o selo
    // quando o usuário realmente acessar a página de Novidades.
    setShowIntroModal(true);
  };

  const iniciarTourNovidades = () => {
    setShowIntroModal(false);
    setShowUserDropdown(true);
    setRunTourNovidades(true);
  };

  const handleJoyrideCallback = (data) => {
    const { status, index, type } = data;
    if (type === 'step:after') {
      setTourStepIndex(index + 1);
    }
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];
    if (finishedStatuses.includes(status)) {
      setRunTourNovidades(false);
      setTourStepIndex(0);
      setShowUserDropdown(false);
    }
  };

  const handleAjuda = () => {
    const MySwal = Swal;
    MySwal.fire({
      title: 'Só um instante',
      text: 'Estamos carregando os tutoriais.',
      icon: 'info',
      confirmButtonText: 'OK',
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      timerProgressBar: true,
      timer: 2000,
      didOpen: () => {
        MySwal.showLoading();
      },
    });
    axios.get('/api/users/', { dest: 'ajuda', dataPost: [location.pathname] }).then((res) => {
      MySwal.hideLoading();
      const data = res.data;

      let buttonLink = '';
      let buttonChat = '<a class="btn btn-success rounded btn-sm ml-2" target="_blank" href="https://tawk.to/chat/62dee31b54f06e12d88b4709/1g8rae9bv">Chat</a>';

      if (res.data.length > 0) {
        buttonLink = `<a class="btn btn-primary rounded btn-sm"  target="_blank" href=${data[0].link_tutorial}>Tutoriais</a>`;
        window.open(data[0].link_tutorial, '_blank');
      }
    });
  };

  useEffect(() => {
    setOcultaMenus(false);
    let imgPerfil_ = users[12];
    let bloqConta_ = users[28];
    const vincGoogle = users[25];
    const imgGoogle = users[24];
    const expirou = users[29];


    if (vincGoogle === 't' && imgGoogle !== null && imgGoogle !== '') {
      imgPerfil_ = imgGoogle;
      configContext.dispatch({ type: IMGPERFIL, imgPerfil: imgPerfil_ });
    } else {
      if (imgPerfil_ > 0) {
        const imgPerfil = parseInt(imgPerfil_);
        configContext.dispatch({ type: IMGPERFIL, imgPerfil: imgPerfil });
      } else {
        configContext.dispatch({ type: IMGPERFIL, imgPerfil: 0 });
      }
    }

    if (usersRt !== null) {
      const username_ = usersRt[4].split(' ');
      setUsername(username_[0]);
      configContext.dispatch({ type: NOMEPERFIL, nomePerfil: username_[0] });
    }
    if (usersRt[17].indexOf('DEMO') !== -1 || usersRt[17].indexOf('demo') !== -1) {
      setIsDemonstracao(true);
    }

    // Evita reaproveitar cache antigo que pode conter markup/estilos antigos
    // (isso fazia o dropdown voltar para o layout anterior ao recarregar).
    if (localStorage.getItem('notyEsp__') !== null) {
      localStorage.removeItem('notyEsp__');
    }

    const fetchDadosIni = async () => {
      const resultado = await CheckSessaoUser(true);
      if (!resultado || !resultado.user) return;
      setDataIni(resultado.user);
      if (resultado.user.possuiEmpresas === 'ficticio') {
        dispatch({ type: TIPOTESTE, tipoTeste: 1 });
      } else {
        dispatch({ type: TIPOTESTE, tipoTeste: 0 });
      }
    };
    // handleTimerUser(configContext, location);
    fetchDadosIni();

    // Verificar status do onboarding - apenas verifica sessionStorage[38]
    if (usersRt && usersRt[38] === 't') {
      setOnboardingIncompleto(true);
    } else {
      setOnboardingIncompleto(false);
    }

  }, []);

  const handleReturnImage = (imgPerfil) => {
    switch (imgPerfil) {
      case 1:
        return perfilAvatar1;
      case 2:
        return perfilAvatar2;
      case 3:
        return perfilAvatar3;
      case 4:
        return perfilAvatar4;
      case 5:
        return perfilAvatar5;
      case 6:
        return perfilAvatar6;
      case 7:
        return perfilAvatar7;
      case 8:
        return perfilAvatar8;
      case 9:
        return perfilAvatar9;
      case 10:
        return perfilAvatar10;
      case 11:
        return perfilAvatar11;
      case 12:
        return perfilAvatar12;
      case 13:
        return perfilAvatar13;
      case 14:
        return perfilAvatar14;
      case 15:
        return perfilAvatar15;
      case 16:
        return perfilAvatar16;
      case 17:
        return perfilAvatar17;
      case 18:
        return perfilAvatar18;
      case 19:
        return perfilAvatar19;
      case 20:
        return perfilAvatar20;
      case 21:
        return perfilAvatar21;
      case 22:
        return perfilAvatar22;
      case 23:
        return perfilAvatar23;
      case 24:
        return perfilAvatar24;
      case 25:
        return perfilAvatar25;
      case 26:
        return perfilAvatar26;
      case 27:
        return perfilAvatar27;
      case 28:
        return perfilAvatar28;
      case 29:
        return perfilAvatar29;
      case 30:
        return perfilAvatar30;
      case 31:
        return perfilAvatar31;
      case 32:
        return perfilAvatar32;
      default:
        return perfilAvatar0;
    }
  };

  const handleAtivarAlertas = () => {
    setBoolAlertas(!boolAlertas);
  };

  const checkOnlineStatus = () => {
    const now = new Date();
    const diaSemana = now.getDay();
    const hora = now.getHours();
    const minutos = now.getMinutes();
    const horaAtual = hora + minutos / 60;
    const isDiaUtil = diaSemana >= 1 && diaSemana <= 5;
    const isPeriodoManha = horaAtual >= 8 && horaAtual <= 11.25;
    const isPeriodoTarde = horaAtual >= 13 && horaAtual <= 17.25;
    setIsOnline(isDiaUtil && (isPeriodoManha || isPeriodoTarde));
  };

  useEffect(() => {
    if (configContext.state.moduloAtual !== moduloAtual) {
      setModuloAtual(configContext.state.moduloAtual);
    }
  }, [configContext.state.moduloAtual]);

  useEffect(() => {
    if (configContext.state.changedDataUser === true) {
      axios.get('/api/users/', { dest: 'carregaMenu' }).then((res) => {
        const response = res.data;


        const menuUsuario = response;
        configContext.dispatch({ type: MENU_USUARIO, menuUsuario: menuUsuario });
        configContext.dispatch({ type: CHANGEDDATAUSER, changedDataUser: false });
      });
    }

    checkOnlineStatus();
    const intervalId = setInterval(checkOnlineStatus, 60000);
    return () => { clearInterval(intervalId); };
  }, []);

  // useEffect(() => {
  //   if (isNewNoti === true) {
  //     const notificacoes_ = notificacoesArray;
  //     if (notificacoes_.length > 0) {
  //       let count = 0;
  //       const montaNotificacoes = notificacoes_.map((notificacao) => {
  //         const imgUs = handleReturnImage(parseInt(notificacao.img));
  //         const message = notificacao.message.split('|');
  //         count++;
  //         return (
  //           <ListGroup.Item
  //             as='li'
  //             bsPrefix=' '
  //             className='notification'
  //             key={'notificacao' + count.toString()}
  //           >
  //             <Media>
  //               <img
  //                 className='img-radius'
  //                 src={imgUs}
  //                 alt='Generic placeholder'
  //               />
  //               <Media.Body>
  //                 <p>
  //                   <strong>{notificacao.usuario}</strong>
  //                   <span className='n-time text-muted'>
  //                     <i className='icon feather icon-clock m-r-10' />
  //                     {notificacao.dataHora}
  //                   </span>
  //                 </p>
  //                 <p>{message[1]}</p>
  //               </Media.Body>
  //             </Media>
  //           </ListGroup.Item>
  //         );
  //       });
  //       setNotificacoes(montaNotificacoes);
  //       localStorage.setItem('notyEsp__', JSON.stringify(notificacoesArray));
  //     }
  //     setIsNewNoti(false);
  //   }
  // }, [isNewNoti]);

  useEffect(() => {
    const { imgPerfil, nomePerfil } = configContext.state;

    if (isNaN(imgPerfil)) {
      setUsername(nomePerfil);
      setAvatarAtual(imgPerfil);

      return;
    }
    // if (imgPerfil.indexOf('http') !== -1) {
    //   setUsername(nomePerfil);
    //   setAvatarAtual(imgPerfil);
    //
    // }

    const img_ = handleReturnImage(imgPerfil);

    setAvatarAtual(img_);
    setUsername(nomePerfil);
  }, [configContext.state.imgPerfil, configContext.state.nomePerfil]);


  useEffect(() => {
    if (caminhoAtual.startsWith('/inicio')) {
      setOcultaMenus(true);
    } else {
      setOcultaMenus(false);
    }
  }, [caminhoAtual]);

  const handleLogout = async () => {
    try {
      logout();
    } catch (err) { }
  };

  return (
    <React.Fragment>
      <Joyride
        steps={tourSteps}
        run={runTourNovidades}
        stepIndex={tourStepIndex}
        continuous
        showProgress={false}
        showSkipButton
        styles={{
          options: {
            zIndex: 9999,
          },
        }}
        locale={{
          back: 'Anterior',
          close: 'Fechar',
          last: 'Concluir',
          next: 'Próximo',
          skip: 'Pular',
          nextLabelWithProgress: 'Próximo (Passo {step} de {steps})',
        }}
        callback={handleJoyrideCallback}
      />
      <Modal
        show={showIntroModal}
        onHide={() => setShowIntroModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Novidades do Sistema</Modal.Title>
        </Modal.Header>
        <Modal.Body className='justify-content-center'>
          <div className='text-center mb-3'>
            <i className='mdi mdi-star-circle text-warning f-34 mr-2' />
            <br />
            <div className='text-left'>
              <p className='mb-2'>Preparamos um espaço dedicado para você acompanhar todas as atualizações e novidades do Espião Cloud.</p>
              <p className='mb-0'>Vamos te mostrar rapidamente onde encontrar essas informações.</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='secondary'
            onClick={() => setShowIntroModal(false)}
          >
            Mais tarde
          </Button>
          <Button
            variant='primary'
            onClick={iniciarTourNovidades}
          >
            Começar tour
          </Button>
        </Modal.Footer>
      </Modal>
      <ListGroup
        as='ul'
        bsPrefix=' '
        className='navbar-nav ml-auto'
      >
        {/* Badge de Onboarding Incompleto */}
        {onboardingIncompleto && (
          <ListGroup.Item
            as='li'
            bsPrefix=' '
            style={{ marginRight: '15px' }}
          >
            <Tooltip
              title='Complete a configuração inicial para começar a receber documentos fiscais'
              placement='bottom'
              arrow
            >
              <Link
                to='/dashboard'
                className='d-inline-block position-relative'
                style={{ textDecoration: 'none' }}
              >
                <i
                  className='mdi mdi-progress-alert icon f-24 text-warning'
                  style={{ position: 'relative' }}
                >
                  <span
                    className='badge badge-pill badge-warning'
                    style={{
                      position: 'absolute',
                      top: '-8px',
                      right: '-8px',
                      fontSize: '9px',
                      padding: '3px 6px',
                      animation: 'pulse 2s infinite',
                      fontWeight: '600',
                    }}
                  >
                    !
                  </span>
                </i>
              </Link>
            </Tooltip>
          </ListGroup.Item>
        )}
        {mostrarAtalhoNovidades && (
          <ListGroup.Item
            as='li'
            bsPrefix=' '
          >
            <Tooltip
              title='Novidades do Sistema'
              placement='bottom'
              arrow
            >
              <Link
                to='#'
                className='d-inline-block'
                onClick={handleClickNovidadesStar}
              >
                <i
                  className='mdi mdi-star-circle icon f-24 text-warning'
                  style={{ position: 'relative' }}
                >
                  {mostrarBadgeNovidades && (
                    <span
                      className='badge badge-pill badge-danger'
                      style={{
                        position: 'absolute',
                        top: '-8px',
                        right: '-8px',
                        fontSize: '8px',
                        padding: '2px 5px',
                        animation: 'pulse 2s infinite',
                      }}
                    >
                      NOVO
                    </span>
                  )}
                </i>
              </Link>
            </Tooltip>
          </ListGroup.Item>
        )}
        <ListGroup.Item
          as='li'
          bsPrefix=' '
        >
          <Dropdown alignRight={!rtlLayout} show={showHelpDropdown} onToggle={(isOpen) => setShowHelpDropdown(isOpen)}>
            <Dropdown.Toggle
              as={Link}
              variant='link'
              to='#'
              id='dropdown-help'
              className='btn btn-sm px-3 py-1 d-flex align-items-center border'
              style={{ borderRadius: '20px', fontSize: '13px', fontWeight: '500', lineHeight: '1' }}
            >
              <i className='fa fa-question-circle f-13 mr-2' /> Suporte
            </Dropdown.Toggle>
            <Dropdown.Menu
              alignRight
              className='profile-notification'
            >
              <h6 className='mt-3 mb-2 mx-3 text-muted'>Ajuda</h6>
              <hr className='mt-1 mb-0' />
              <ListGroup
                as='ul'
                bsPrefix=' '
                variant='flush'
                className='pro-body mt-0'
              >
                {/* <ListGroup.Item as='li' bsPrefix=' '><Link to='#' className="dropdown-item"><i className="feather icon-settings"/> Settings</Link></ListGroup.Item> */}

                <ListGroup.Item
                  as='li'
                  className='p-0 border-0'
                >
                  <Link
                    to='#!'
                    onClick={() => { handleAjuda(configContext, location); setShowHelpDropdown(false); }}
                    className='dropdown-item d-flex flex-column text-decoration-none p-3 hover-bg-light'
                  >
                    <div className='d-flex align-items-center mb-2'>
                      <i className='fa fa-book mr-2 f-16 text-primary' />
                      <span className='font-weight-bold text-muted'>Central de ajuda</span>
                    </div>

                    <div className='pl-4 border-left ml-1'>
                      <p className='f-13 text-muted mb-0'>Tutoriais e instruções de uso da plataforma</p>
                    </div>
                  </Link>
                </ListGroup.Item>
                <ListGroup.Item
                  as='li'
                  className='p-0 border-0'
                >
                  <Link
                    to='/usuarios/tickets'
                    onClick={() => setShowHelpDropdown(false)}
                    className='dropdown-item d-flex flex-column text-decoration-none p-3 hover-bg-light'
                  >
                    <div className='d-flex align-items-center mb-2'>
                      <i className='mdi mdi-ticket-outline mr-2 f-16 text-primary' />
                      <span className='font-weight-bold text-muted'>Tickets / Chamados</span>
                    </div>
                    <div className='pl-4 border-left ml-1'>
                      <p className='f-13 text-muted mb-0'>Abra e acompanhe chamados com nosso suporte</p>
                    </div>
                  </Link>
                </ListGroup.Item>
                <ListGroup.Item
                  as='li'
                  className='p-0 border-0'
                >
                  <a
                    href='https://tawk.to/appespiaocloud'
                    target='_blank'
                    rel='noreferrer noopener'
                    onClick={() => setShowHelpDropdown(false)}
                    className='dropdown-item d-flex flex-column text-decoration-none p-3 hover-bg-light'
                  >
                    <div className='d-flex align-items-center mb-2'>
                      <i className='fa fa-comment mr-2 f-16 text-primary' />
                      <span className='font-weight-bold text-muted'>Chat ao vivo</span>
                      <span
                        className={`ml-2 rounded-circle ${isOnline ? 'bg-success' : 'bg-danger'}`}
                        style={{ width: '8px', height: '8px' }}
                        title={isOnline ? 'Online' : 'Offline'}
                      />
                    </div>

                    <div className='pl-4 border-left ml-1'>
                      <p className='f-13 text-muted mb-1'>Atendimento em tempo real</p>
                      <p className='f-13 text-muted mb-1'>Segunda a Sexta (Horário de Brasília)</p>

                      <div className='pl-2 mt-2'>
                        <p className='f-13 text-muted mb-1'>
                          <span className='d-inline-block mr-2'>Manhã:</span>08:00 - 11:15
                        </p>
                        <p className='f-13 text-muted mb-2'>
                          <span className='d-inline-block mr-2'>Tarde:</span>13:00 - 17:15
                        </p>
                      </div>
                    </div>
                  </a>
                </ListGroup.Item>
              </ListGroup>
              <small className='float-right p-2'>
                <a href='#'>{`v.${packageJson.version}`}</a>
              </small>
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>
        <ListGroup.Item
          as='li'
          bsPrefix=' '
        >
          <Dropdown
            alignRight={!rtlLayout}
            show={showBellDropdown}
            onToggle={(isOpen) => setShowBellDropdown(isOpen)}
            onClick={() => {
              markReadBatch().catch(() => { });
            }}
          >
            <Dropdown.Toggle
              as={Link}
              variant='link'
              to='#'
              id='dropdown-basic'
            >
              <i className='feather icon-bell icon' />
              <span className='badge badge-pill badge-danger'>{spanNotificacoes}</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className='pb-0'>
              <h6 className='ml-3 text-c-blue '>
                <span className='mdi mdi-bell'></span>
              </h6>
              <ListGroup
                as='ul'
                bsPrefix=' '
                variant='flush'
                className='px-2'
                style={{ maxHeight: '350px', overflow: 'auto' }}
              >
                {notificacoesArray}
              </ListGroup>
              <div className='border-0 m-0 p-0 text-center hei-45'>
                <Link
                  to='/usuarios/notificacoes'
                  onClick={() => setShowBellDropdown(false)}
                  className='text-center '
                  style={{ fontSize: '12px', color: '#4099ff' }}
                >
                  Ver tudo
                </Link>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>
        <ListGroup.Item
          as='li'
          bsPrefix=' '
        >
          <Dropdown
            alignRight={!rtlLayout}
            className='drp-user'
            id='menuRP'
            show={showUserDropdown}
            onToggle={(isOpen) => {
              // Mantém aberto durante o tour
              if (runTourNovidades) {
                setShowUserDropdown(true);
                return;
              }
              setShowUserDropdown(isOpen);
            }}
          >
            <Dropdown.Toggle
              as={Link}
              variant='link'
              to='#'
              id='dropdown-basic'
            >
              <img
                src={avatarAtual}
                className='img-radius border-none wid-40'
                alt='User Profile'
              />
            </Dropdown.Toggle>
            <Dropdown.Menu
              alignRight
              ref={ref}
              className='profile-notification'
              id='menuR'
            >
              <div className='pro-head'>
                <img
                  src={avatarAtual}
                  className='img-radius'
                  alt='User Profile'
                />
                <span>{username}</span>

                <Tooltip
                  title={'Sair'}
                  placement='top'
                  arrow
                >
                  <Link
                    to='#'
                    className='dud-logout'
                    onClick={handleLogout}
                  >
                    <i className='mdi mdi-logout f-16' />
                  </Link>
                </Tooltip>
              </div>
              <Row className=' align-items-center justify-content-center bg-c-green text-white mt-0'>
                <Col sm={12}>
                  <Card className='mt-0 shadow-none bg-c-green mb-0'>
                    <Card.Header className='py-1 px-0'>
                      <Card.Title
                        as='h5'
                        className=' w-100'
                      >
                        <Tooltip
                          title='Conta Atual'
                          placement='top'
                          arrow
                        >
                          <Link
                            to='#'
                            onClick={() => {
                              setAccordionKey(accordionKey !== 1 ? 1 : 0);
                            }}
                            aria-controls='accordion1'
                            aria-expanded={accordionKey === 1}
                            className={'shadow-none text-decoration-none'}
                          >
                            <p className='mb-0 f-13 text-white ml-2 mt-0 f-w-400'>
                              <span className='mdi mdi-office-building f-13 text-white mr-2'></span>
                              {nomeEmpresa}
                              <span className={`float-right mdi ${accordionKey === 1 ? 'mdi-arrow-up' : 'mdi-arrow-down'} mr-1`}></span>
                            </p>
                          </Link>
                        </Tooltip>
                      </Card.Title>
                    </Card.Header>
                    <Collapse
                      in={accordionKey === 1}
                      className='bg-primary'
                    >
                      <div id='accordion1'>
                        <Card.Body className='pb-1 px-2'>
                          <Row className=' align-items-center justify-content-left text-white'>
                            <Col>
                              <p className='mt-2 mb-0 f-12 text-white ml-2 '>
                                {isDemonstracao === false ? cnpjCpf : ''}
                                <br />
                                {nomeEmpresa}
                                {tituloPlano !== '' ? (
                                  <>
                                    <br />

                                    {tituloPlano}
                                  </>
                                ) : (
                                  ''
                                )}
                              </p>
                            </Col>
                          </Row>
                          <Row className='mb-0 mt-0'>
                            <Col>
                              <hr className='text-white bg-white mb-1 mt-1' />

                              <Link
                                to={'#!'}
                                className={'shadow-none text-decoration-none text-white f-12 float-right'}
                                onMouseEnter={() => {
                                  setDisplayFecharDropConta(true);
                                }}
                                onMouseLeave={() => {
                                  setDisplayFecharDropConta(false);
                                }}
                                onClick={() => {
                                  setAccordionKey(accordionKey !== 1 ? 1 : 0);
                                }}
                              >
                                {displayFecharDropConta === true && 'Fechar'}
                                <span className='ml-2 mdi mdi-close-circle-outline f-13'></span>
                              </Link>
                              {varias === true && (
                                <Link
                                  to={'#!'}
                                  className={'shadow-none text-decoration-none text-white f-12 float-left'}
                                  onMouseEnter={() => {
                                    setDisplayTrocarEmpresa(true);
                                  }}
                                  onMouseLeave={() => {
                                    setDisplayTrocarEmpresa(false);
                                  }}
                                  onClick={() => {
                                    sessionStorage.removeItem('ddesp');
                                    window.location.href = '/auth/acesso-varias-empresas';
                                  }}
                                >
                                  <span className='mdi mdi-arrow-u-left-top-bold'>{displayTrocarEmpresa === true && ' Trocar empresa'}</span>
                                </Link>
                              )}
                            </Col>
                          </Row>
                        </Card.Body>
                      </div>
                    </Collapse>
                  </Card>
                </Col>
              </Row>

              <hr className='mb-0 mt-0' />
              <ul className='list-unstyled'>
                {ocultaMenus === false && (
                  <>
                    <Dropdown.Item
                      as='li'
                      bsPrefix=' '
                      className='mt-2'
                    >
                      <Link
                        to={moduloAtual === 1 ? '/resgate/editarPerfil' : '/usuarios/editarPerfil'}
                        className='dropdown-item'
                      // onClick={() => {
                      //   moduloAtual === 1 ? history.push('/resgate/editarPerfil') : history.push('/usuarios/editarPerfil');
                      // }}
                      >
                        <i className='mdi mdi-account-edit f-16' /> Editar Perfil
                      </Link>
                    </Dropdown.Item>



                    {/* Menu Segurança - apenas para master */}
                    {isMasterUser && (
                      <Dropdown.Item
                        as='li'
                        bsPrefix=' '
                      >
                        <Link
                          to='/seguranca'
                          className='dropdown-item'
                          onClick={handleOpenSeguranca}
                        >
                          <i className='feather icon-shield f-16' /> Segurança
                        </Link>
                      </Dropdown.Item>
                    )}




                    {/* <Dropdown.Item
                      as='li'
                      bsPrefix=' '
                      className='mb-2'
                    >
                      <Link
                        to='#'
                        className='dropdown-item'
                        onClick={() => {
                          history.push('/usuarios');
                        }}
                      >
                        <i className='mdi mdi-account-group-outline f-16' /> Usuários
                      </Link>
                    </Dropdown.Item> */}
                    <Dropdown.Item
                      as='li'
                      bsPrefix=' '
                    >
                      <Link
                        to='/integracao'
                        className='dropdown-item'
                      // onClick={() => {
                      //   setShowModalIntegracoes(true);
                      // }}
                      >
                        <i className='mdi mdi-connection f-16' /> Integrações
                      </Link>
                    </Dropdown.Item>

                    <Dropdown.Item
                      as='li'
                      bsPrefix=' '
                    >
                      <Link
                        to={moduloAtual === 0 ? '/meuPlano' : '/resgate/meuPlano'}
                        className='dropdown-item'
                      >
                        <i className=' mdi mdi-order-bool-ascending-variant f-16' /> Meu plano
                      </Link>
                    </Dropdown.Item>

                    {!isDemonstracao && (
                      <Dropdown.Item
                        as='li'
                        bsPrefix=' '
                      >
                        <Link
                          to={moduloAtual === 0 ? '/faturas' : '/resgate/faturas'}
                          className='dropdown-item'
                        // onClick={() => {
                        //   moduloAtual === 0 ? history.push('/faturas') : history.push('/resgate/faturas');
                        // }}
                        >
                          <i className=' fa fa-hand-holding-usd f-16' /> Faturas
                          {/* <Badge
                            color='blue'
                            content={'Em breve'}
                            className='ml-2  f-10 rounded'
                          /> */}
                        </Link>
                      </Dropdown.Item>
                    )}
                  </>
                )}
                <Dropdown.Item
                  as='li'
                  bsPrefix=' '
                >
                  <Link
                    to='/novidades'
                    className='dropdown-item'
                    id='menuNovidades'
                    onClick={() => {
                      // Marca como visto ao acessar Novidades pelo menu
                      localStorage.setItem('novidadesBadgeVisto', 'true');
                      setMostrarBadgeNovidades(false);
                      setMostrarAtalhoNovidades(false);
                    }}
                  >
                    <i className='mdi mdi-new-box f-16' /> Novidades
                  </Link>
                </Dropdown.Item>
                <Dropdown.Item
                  as='li'
                  bsPrefix=' '
                  className='mb-2'
                >
                  <Link
                    to='#'
                    className='dropdown-item'
                    onClick={handleLogout}
                  >
                    <i className='mdi mdi-logout f-16' /> Sair
                  </Link>
                </Dropdown.Item>
              </ul>
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>
      </ListGroup>
      {showModalIntegracoes === true && (
        <ModalIntegracoes
          showModalIntegracoes={showModalIntegracoes}
          setShowModalIntegracoes={setShowModalIntegracoes}
        />
      )}
      <ModalCartaAberta />
      <CupomDesconto />

      {/* Modal de detalhe da notificação */}
      <Modal
        show={modalNotif !== null}
        onHide={() => setModalNotif(null)}
        centered
        size='lg'
      >
        {modalNotif && (
          <>
            <Modal.Header
              closeButton
              className={`bg-${modalNotif.variant || 'primary'} text-white`}
              style={{ borderBottom: 'none' }}
            >
              <Modal.Title style={{ fontSize: '16px' }}>
                {modalNotif.titulo}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className='p-4'>
              <p style={{ whiteSpace: 'pre-wrap', fontSize: '15px' }}>
                {modalNotif.texto}
              </p>
              <hr />
              <small className='text-muted'>{modalNotif.dhText}</small>
            </Modal.Body>
            {modalNotif.link && modalNotif.link !== 'null' && (() => {
              const raw = String(modalNotif.link || '').trim();
              const href = raw.startsWith('tickets/') ? `/${raw}` : raw;
              const isInternal = href.startsWith('/');
              return (
                <Modal.Footer>
                  {isInternal ? (
                    <Link
                      to={href}
                      className='btn btn-primary btn-sm'
                      onClick={() => setModalNotif(null)}
                    >
                      Visualizar
                    </Link>
                  ) : (
                    <a
                      href={href}
                      target='_blank'
                      rel='noreferrer'
                      className='btn btn-primary btn-sm'
                    >
                      Visualizar
                    </a>
                  )}
                  <Button variant='secondary' size='sm' onClick={() => setModalNotif(null)}>
                    Fechar
                  </Button>
                </Modal.Footer>
              );
            })()}
          </>
        )}
      </Modal>
    </React.Fragment>
  );
};

export default NavRight;
